import { render, staticRenderFns } from "./OnboardingStepsDrawer.vue?vue&type=template&id=30515d29&"
import script from "./OnboardingStepsDrawer.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports